/**
 * Applies text transforms in a fixed order: trim -> case -> maxLength/truncate -> pad.
 * Browser-safe (no node:* imports). For fixed-width export, the generator's own
 * `length` enforcement still runs LAST and wins over pad/truncate here.
 */
export function formatTextValue(value, spec) {
    let str = value === null || value === undefined ? '' : String(value);
    if (spec.trim) {
        str = str.trim();
    }
    if (spec.case === 'upper') {
        str = str.toUpperCase();
    }
    else if (spec.case === 'lower') {
        str = str.toLowerCase();
    }
    else if (spec.case === 'title') {
        str = str.replace(/\b\w/g, (c) => c.toUpperCase());
    }
    if (spec.maxLength != null && spec.maxLength >= 0 && str.length > spec.maxLength) {
        str = spec.truncateFrom === 'start'
            ? str.slice(str.length - spec.maxLength)
            : str.slice(0, spec.maxLength);
    }
    if (spec.pad && spec.pad.to > 0 && spec.pad.char.length === 1 && str.length < spec.pad.to) {
        const fill = spec.pad.char.repeat(spec.pad.to - str.length);
        str = spec.pad.align === 'right' ? str + fill : fill + str;
    }
    return str;
}
//# sourceMappingURL=text-formatting.js.map